import { render, staticRenderFns } from "./nodealinfo.vue?vue&type=template&id=700982df&scoped=true&"
import script from "./nodealinfo.vue?vue&type=script&lang=js&"
export * from "./nodealinfo.vue?vue&type=script&lang=js&"
import style0 from "./nodealinfo.vue?vue&type=style&index=0&id=700982df&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700982df",
  null
  
)

export default component.exports